import ApplicantsQuickTable from "@/components/AdminDashboard/ApplicantsQuickTable";
import CompanyInsights from "@/components/AdminDashboard/CompanyInsights";
// import FeedbackGraphs from "@/components/AdminDashboard/FeedbackGraphs";
import FreeTrailInsights from "@/components/AdminDashboard/FreeTrailInsights";
import HiringInsights from "@/components/AdminDashboard/HiringInsights";
// import FeedbackLogs from "@/components/AdminDashboard/FeedbackLogs";
import QuickData from "@/components/AdminDashboard/QuickData";
import ResourceUtilization from "@/components/AdminDashboard/ResourceUtilization";
import UserLogs from "@/components/AdminDashboard/UserLogs";
import UserQuickData from "@/components/AdminDashboard/UserQuickData";
// import DateFilter from "@/components/DatePicker";

import useBreadCrumb from "@/context/BreadCrumbContext";
import useUserName from "@/context/UserNameContext";
// import Header from "@/components/Header";
import moment from "moment";
import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";

const AdminDashboard = () => {
	// const navigate = useNavigate();
	// const [activeTab, setActiveTab] = useState<"Analytics" | "account">(
	// 	"Analytics"

	// );

	const { setBreadCrumb } = useBreadCrumb();
	const { userName } = useUserName();

	const [dates, setDates] = useState({
		fromDate: "",
		toDate: moment().format("YYYY-MM-DD"),
	});

	useEffect(() => {
		setDates({
			fromDate: "",
			toDate: moment().format("YYYY-MM-DD"),
		});
		setBreadCrumb({
			mainLabel: {
				label: "Home",
				link: "home",
			},
			currentLabel: "Overview",
		});
	}, []);

	// useEffect(() => {
	// 	localStorage.getItem("role") === "guest" ? navigate("/jobList") : "";
	// }, []);
	// const handleTabChange = (tab: "Analytics" | "account") => {
	// 	setActiveTab(tab);
	// };

	return (
		<>
			<h3 className="text-2xl ml-2 mb-4 font-light">
				Welcome, {userName}!
			</h3>
			<main className="">
				<div className="pb-6">
					<div className="flex flex-col md:flex-row items-center justify-between w-full mb-4 border-b border-gray-300">
						{/* <DateFilter dates={dates} setDates={setDates}></DateFilter> */}
					</div>
					<>
						{/* Small screens (flex layout) */}
						<div className="flex flex-col gap-6 lg:hidden">
							{["guest", "Talentick_user"].includes(localStorage.getItem("role") || "") ? (
								<UserQuickData date={dates} />
							) : (
								<QuickData date={dates} />
							)}

							{localStorage.getItem("role") === "guest" ? (
								<FreeTrailInsights />
							) : (
								<CompanyInsights />
							)}

							<HiringInsights />

							<UserLogs />

							{["guest", "Talentick_user", "bluetick-admin"].includes(localStorage.getItem("role") || "") ? (
								<ApplicantsQuickTable />
							) : (
								<ResourceUtilization />
							)}
						</div>

						{/* Medium and up screens (grid layout) */}
						<div className="hidden lg:grid lg:grid-cols-[65%_35%] gap-y-6 gap-x-6">
							{/* Left Column */}
							<div className="w-full md:w-auto">
								{["guest", "Talentick_user"].includes(localStorage.getItem("role") || "") ? (
									<UserQuickData date={dates} />
								) : (
									<QuickData date={dates} />
								)}

								<UserLogs />
							</div>

							{/* Right Column */}
							<div className="w-full md:w-auto space-y-6">
								<div>
									{localStorage.getItem("role") === "guest" ? (
										<FreeTrailInsights />
									) : (
										<CompanyInsights />
									)}
								</div>

								{["guest", "Talentick_user", "bluetick-admin"].includes(localStorage.getItem("role") || "") ? (
									<ApplicantsQuickTable />
								) : (
									<ResourceUtilization />
								)}

								<HiringInsights />
							</div>
						</div>
					</>

				</div>
			</main>
		</>
	);
};

export default AdminDashboard;
